import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    createTextVNode as _$ct,
} from 'intact';
import {Bubble, Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Button, {
                'ev-click': this.playSlow,
                'children': '慢速播放'
            }),
            _$cc(Button, {
                'ev-click': this.playFast,
                'children': '快速播放'
            }),
            _$cc(Button, {
                'ev-click': this.playCharacterByCharacter,
                'children': '逐字播放'
            })
        ], 4, 'bubble-demo-typing-actions'),
        _$cc(Bubble, {
            'key': this.get('bubbleKey'),
            'avatar': true,
            'roleName': 'AI 助手',
            'content': this.get('content'),
            'typing': this.get('typing'),
            'variant': 'plain',
            'ev-typingComplete': this.onTypingComplete,
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['extra'] = function($super) {
                            return (
                                _$ce(2, 'div', [
                                    _$ce(2, 'div', [
                                        _$ct('当前模式：'),
                                        this.get('modeLabel')
                                    ], 0),
                                    _$ce(2, 'div', [
                                        _$ct('完成次数：'),
                                        this.get('completeCount')
                                    ], 0)
                                ], 4, 'bubble-demo-typing-extra')
                            );
                        }),
                        (__$blocks['extra'] = function($super, data) {
                            var block = $blocks['extra'];
                            var callBlock = function() {
                                return _$blocks['extra'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        }, this.get('bubbleKey'))
    ], 0, 'bubble-demo-typing');
};